// JavaScript file for haijiao77
export const channelCode = 'haijiao77';
